import { useState } from 'react'
import { NewPassword, type Member } from '@rp/contracts'
import { Button, Dialog } from '../../design'
import { SETTINGS_COPY } from './copy'
import { PasswordInput } from './PasswordInput'
import { MEMBER_PASSWORD_COPY } from './passwordCopy'

type MemberPasswordDialogProps = {
  member: Member | null
  pending: boolean
  onCancel: () => void
  onConfirm: (member: Member, password: string) => void
}

const problemOf = (password: string): string | undefined => {
  if (password === '') return MEMBER_PASSWORD_COPY.required
  return NewPassword.safeParse(password).success ? undefined : MEMBER_PASSWORD_COPY.tooShort
}

export const MemberPasswordDialog = ({ member, pending, onCancel, onConfirm }: MemberPasswordDialogProps) => {
  const [password, setPassword] = useState('')
  const [problem, setProblem] = useState<string | undefined>(undefined)
  const close = () => {
    setPassword('')
    setProblem(undefined)
    onCancel()
  }
  const confirm = () => {
    const found = problemOf(password)
    setProblem(found)
    if (found !== undefined || member === null) return
    onConfirm(member, password)
    setPassword('')
  }
  return (
    <Dialog
      open={member !== null}
      title={MEMBER_PASSWORD_COPY.resetTitle}
      onClose={close}
      footer={
        <>
          <Button onClick={close}>{SETTINGS_COPY.cancel}</Button>
          <Button variant="primary" pending={pending} pendingLabel={MEMBER_PASSWORD_COPY.resetting} onClick={confirm}>
            {MEMBER_PASSWORD_COPY.resetConfirm}
          </Button>
        </>
      }
    >
      {member === null ? null : (
        <>
          <p className="measure">{MEMBER_PASSWORD_COPY.resetBody(member.email)}</p>
          <PasswordInput id="reset-password" value={password} error={problem} onValue={setPassword} />
        </>
      )}
    </Dialog>
  )
}
